import React, { useRef, useState } from "react";
import { api } from "@/lib/api";

export const cleanCap = (v) => (v || "").replace(/\D/g, "").slice(0, 5);

// Dato un CAP italiano compila città e provincia; con più località propone la scelta.
export function useCapAutofill(fill) {
  const [places, setPlaces] = useState([]);
  const [picked, setPicked] = useState(0);
  const [msg, setMsg] = useState("");
  const auto = useRef(false);
  const put = (p) => { auto.current = true; fill(p); };
  const clear = () => { if (auto.current) { auto.current = false; fill({ city: "", province: "" }); } };
  const lookup = async (cap) => {
    setPlaces([]); setMsg("");
    if (cap.length !== 5) { clear(); if (cap) setMsg("Il CAP deve avere 5 cifre."); return; }
    try {
      const { data } = await api.get(`/geo/postal?country=IT&zip=${cap}`);
      const ps = data?.places || [];
      if (!ps.length) { clear(); setMsg("CAP non trovato: inserisci città e provincia a mano."); return; }
      put(ps[0]); setPicked(0);
      if (ps.length > 1) { setPlaces(ps); setMsg(`${ps.length} località per questo CAP: scegli quella giusta.`); }
      else setMsg(`Località: ${ps[0].city}${ps[0].province ? ` (${ps[0].province})` : ""}`);
    } catch { setMsg(""); }
  };
  const pick = (i) => { setPicked(i); put(places[i]); };
  return { lookup, places, picked, pick, msg };
}

export const CapChoices = ({ cap, testid }) => (
  <>
    {cap.msg && <p className="text-xs text-muted-foreground mt-1" data-testid={`${testid}-msg`}>{cap.msg}</p>}
    {cap.places.length > 1 && <div className="flex flex-wrap gap-1.5 mt-1.5" data-testid={`${testid}-options`}>
      {cap.places.map((p, i) => <button key={i} type="button" onClick={() => cap.pick(i)} className={`rounded-full border px-2.5 py-0.5 text-xs transition-colors ${cap.picked === i ? "border-primary font-semibold" : "border-border text-muted-foreground hover:border-primary"}`} data-testid={`${testid}-option-${i}`}>{p.city}{p.province ? ` (${p.province})` : ""}</button>)}
    </div>}
  </>
);
